export default "__VITE_ASSET__2uqRBtns__"